import { IMAGE_DIR } from '@/shared/constants/linksApi'

export const returnOrdersData = [
    {
        orderNumber: 10089,
        orderDate: 'четверг, 21 сентября 2023 г. в 01:25',
        dateDelivery: 'суббота, 23 сентября 2023 г.',
        addressDelivery: 'г. Нижний Новгород, б-р Мира, д. 33',
        amount: 13278,
        status: 'В обработке',
        orderStatus: 'Выдан покупателю',
        orders: [
            {
                img: IMAGE_DIR + 'cache/catalog/5004-500x500.jpg',
                orderName:
                    'Солнцезащитный крем SPF-50 увлажняющий с УФ пептидами',
                count: 1,
                price: 1290,
            },
            {
                img: IMAGE_DIR + 'cache/catalog/5004-500x500.jpg',
                orderName:
                    'Солнцезащитный крем SPF-50 увлажняющий с УФ пептидами',
                count: 1,
                price: 1290,
            },
            {
                img: IMAGE_DIR + 'cache/catalog/5004-500x500.jpg',
                orderName:
                    'Солнцезащитный крем SPF-50 увлажняющий с УФ пептидами',
                count: 1,
                price: 1290,
            },
        ],
    },
    {
        orderNumber: 10088,
        orderDate: 'четверг, 21 сентября 2023 г. в 01:25',
        dateDelivery: 'суббота, 23 сентября 2023 г.',
        addressDelivery: 'г. Нижний Новгород, б-р Мира, д. 33',
        amount: 13278,
        status: 'В обработке',
        orderStatus: 'Выдан покупателю',
        orders: [
            {
                img: IMAGE_DIR + 'cache/catalog/5004-500x500.jpg',
                orderName:
                    'Солнцезащитный крем SPF-50 увлажняющий с УФ пептидами',
                count: 1,
                price: 1290,
            },
        ],
    },
]
